import LogoVerticalBlanco from 'assets/logo-vertical-blanco';
import { sidebarList, IMenuItem } from 'helpers/constant';
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'hooks/useAppDispatchSelector';
import { usersRoles } from 'helpers/utils';
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuItems, setMenuItems] = useState<IMenuItem[]>(sidebarList);
  const { selectedOrganization } = useAppSelector(state => state?.auth);
  const { t } = useTranslation();
  useEffect(() => {
    const updatedMenuList = menuItems.map(item =>
      location.pathname.startsWith(item.path) ||
      (item?.rootPath && location.pathname.startsWith(item.rootPath))
        ? { ...item, selected: true }
        : { ...item, selected: false },
    );
    setMenuItems([...updatedMenuList]);
  }, [location.pathname]);
  const getLogo = () => {
    if (
      selectedOrganization?.role_name === usersRoles?.SUPER_ADMIN ||
      selectedOrganization?.role_name === usersRoles?.FLEET_MANAGE ||
      !selectedOrganization?.logo_url?.trim()
    ) {
      return (
        <div className="flex logo items-center justify-center lg:justify-start lg:px-2 px-0 mb-4">
          <LogoVerticalBlanco width={140} height={52} fill="#ffffff" />
        </div>
      );
    } else {
      return (
        <div className="flex logo items-center justify-start lg:pl-[15px] lg:pr-3 pl-0 pr-0 max-w-md max-h-16 mb-4">
          <img
            src={selectedOrganization?.logo_url}
            className="h-full w-full object-contain"
            alt=""
          />
        </div>
      );
    }
  };
  return (
    <div className="flex flex-col h-full lg:w-[240px] lg:min-w-[240px] w-[71px] min-w-[71px] bg-black3 py-4 px-4 gap-y-5">
      <div className="flex flex-col flex-1 w-full gap-y-2">
        {getLogo()}
        <div className="flex flex-col gap-y-1 w-full">
          {(menuItems || [])
            .filter(data =>
              data.permissionKey?.length &&
              selectedOrganization?.permissions &&
              Object.entries(selectedOrganization?.permissions).filter(
                ([key, value]) => data.permissionKey?.includes(key) && value?.list,
              ).length
                ? true
                : false,
            )
            .map(item => {
              if (
                item.id === 'BILLING' &&
                !selectedOrganization?.hasMerchant &&
                selectedOrganization?.role_name !== usersRoles?.SUPER_ADMIN
              ) {
                return null;
              }

              return (
                <div
                  className={`flex items-center justify-center lg:justify-start p-[9px] lg:py-2 gap-x-1 cursor-pointer w-full lg:pl-2 lg:pr-2 rounded-1 hover:bg-black4 hover:text-white ${
                    item?.selected ? 'bg-black4' : ''
                  }`}
                  key={item?.id}
                  onClick={() => navigate(item.path)}
                >
                  <>{item?.selected ? item?.activeIcon : item?.icon}</>
                  <label
                    className={`hidden lg:flex flex-1 font-medium text-sm ${
                      item?.selected ? 'text-white' : 'text-light1'
                    } cursor-pointer whitespace-nowrap text-ellipsis overflow-hidden`}
                  >
                    {t(`sidebarListItem.${item?.id}`)}
                  </label>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
